import React from "react";
import { Box, Typography, Container, useTheme } from "@mui/material";
import { Helmet } from "react-helmet";
import SignalsContent from "./Signal/SignalsContent";

const Signals = () => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Signals | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'light'
            ? '#ebebeb'
            : theme.palette.grey[50],
          background: theme.palette.mode === 'light'
            ? '#ebebeb'
            : theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Signals
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              Manage and monitor trading signals across strategies
            </Typography>
          </Box>
          <SignalsContent />
        </Container>
      </Box>
    </>
  );
};

export default Signals; 